﻿export interface KeysetQueryResult<TEntity extends object> {
	/**
	 * Gets the collection of entities returned for the current page.
	 */
	data: TEntity[];

	/**
	 * Gets the total number of items available across all pages.
	 * Note: Calculating this requires a separate COUNT query, which can be expensive for large tables.
	 * Set to null when the total count is not needed to improve performance.
	 */
	totalCount: number | undefined;

	/**
	 * Gets the number of items requested per page.
	 */
	pageSize: number;

	state: KeysetQueryState;
}

export enum KeysetQueryState {
	Undefined = 0,
	IsFirst = 1,
	HasNext = 2,
	HasPrevious = 4,
	IsLast = 8
}
